"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TAIL_SIZE_REM = exports.TAIL_SIZE = exports.WINDOW_EDGE_MARGIN = void 0;

var polished_1 = require("polished");
/**
 * Fixed margin to keep tip from touching the very edge of the window.
 */


exports.WINDOW_EDGE_MARGIN = 12;
/**
 * Size of the pointy tip.
 */

exports.TAIL_SIZE = 10;
exports.TAIL_SIZE_REM = (0, polished_1.rem)(exports.TAIL_SIZE);